import OutsideClickHandler from "react-outside-click-handler";
export default OutsideClickHandler;
